import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "section",
  class: "container position-relative text-white",
  "aria-label": "Text section"
}
const _hoisted_2 = {
  key: 0,
  class: "container list-group",
  "aria-label": "Q+A"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.content)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.content.motto), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.content.prop), 1),
        (_ctx.content.QA)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.QA, ([ question, answer ]) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: question,
                  class: "list-group-item"
                }, [
                  _createElementVNode("p", null, _toDisplayString(question), 1),
                  _createElementVNode("p", null, _toDisplayString(answer), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}